import { CardContent, Box } from '@mui/material';
import { DollarSign } from 'react-feather';
import { MinimalCard } from 'components/styled';

import { Typography, LinearProgress, StatsIcon } from './styles';

function Revenue() {
  return (
    <Box position="relative">
      <MinimalCard $hoverEffect={false} sx={{ mb: 6, pt: 2 }}>
        <CardContent>
          <Typography variant="h2" gutterBottom>
            <Box fontWeight="fontWeightRegular">$ 1.224</Box>
          </Typography>
          <Typography variant="body2" gutterBottom sx={{ mt: 3, mb: 0 }}>
            Total Revenue
          </Typography>

          <StatsIcon>
            <DollarSign />
          </StatsIcon>
          <LinearProgress variant="determinate" value={50} color="secondary" sx={{ mt: 4 }} />
        </CardContent>
      </MinimalCard>
    </Box>
  );
}

export default Revenue;
